// @flow
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import { compose } from 'react-recompose';
import type { StateProps } from './ChangePasswordForm';
import ChangePasswordForm from './ChangePasswordForm';
import ValidationService from '../../../lib/validation';
import { isLoadingSelector } from '../../../modules/LoadingStatus/reducer';
import { changePassword } from '../../../modules/Authentication';

const mapStateToProps = (state): StateProps => ({
  isChangingPassword: isLoadingSelector(state, 'changePassword'),
});

const mapDispatchToProps = {
  onSubmit: changePassword,
};

const validate = values => ({
  oldPassword: ValidationService.validatePresence(values.oldPassword),
  newPassword: ValidationService.validatePassword(values.newPassword),
});

const enhance = compose(connect(mapStateToProps, mapDispatchToProps), reduxForm({ form: 'changePassword', validate }));
export default enhance(ChangePasswordForm);
